<template>
  <d-modal
    class="crm-new-popup load-prices-modal"
    v-if="showModal"
    @close="closeModal"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          Wczytaj cennik z&hellip;
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div
        class="spinner-load"
        v-if="loading">
        <div
          class="spinner-border spinner-border-sm crm-new-popup-spinner"
          role="status"></div>
      </div>
      <div v-if="!loading">
        <d-row>
          <d-col
            cols="12"
            md="6">
            <div class="form-group">
              <label>Typ źródła</label>
              <v-select
                :options="sourceTypeOptions"
                v-model="sourceType"
                placeholder="Wybierz typ źródła..."
                :searchable="false"
                label="text"
                :reduce="item => item.value"
                @input="onSourceTypeChange">
                <template slot="no-options">Brak wyników</template>
              </v-select>
            </div>
          </d-col>
          <d-col
            cols="12"
            md="6">
            <div class="form-group">
              <label>Źródło</label>
              <v-select
                :options="sourceOptions"
                v-model="sourceId"
                :placeholder="sourceOptionsPlaceholder"
                :searchable="true"
                label="name"
                :reduce="item => item.id"
                :disabled="!sourceType"
                :loading="loadingSources">
                <template slot="no-options">Brak wyników</template>
              </v-select>
            </div>
          </d-col>
        </d-row>
        <d-row>
          <d-col
            cols="12"
            md="6">
            <div class="form-group">
              <label>Tryb</label>
              <v-select
                :options="modeOptions"
                v-model="mode"
                placeholder="Wybierz tryb..."
                :searchable="false"
                label="text"
                :reduce="item => item.value">
              </v-select>
            </div>
          </d-col>
        </d-row>

        <div class="popup-box-buttons">
          <d-button
            :theme="'success'"
            class="text-nowrap"
            :disabled="!canSubmit || submitting"
            :class="{ 'isLoading' : submitting }"
            @click.prevent="submitLoadPrices">
            Wczytaj
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="closeModal">
            Anuluj
          </d-button>
        </div>
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'load-prices-modal',
  data () {
    return {
      sourceType: null,
      sourceId: null,
      mode: null,
      sourceOptions: [],
      loading: false,
      loadingSources: false,
      submitting: false
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    entityId: {
      type: [String, Number],
      required: true
    },
    entityType: {
      type: String,
      default: null
    },
    loadEndpoint: {
      type: String,
      required: true
    }
  },
  computed: {
    sourceTypeOptions () {
      return [
        { text: 'Cennik wzorcowy', value: 'PRICE_LIST' },
        { text: 'Klient', value: 'CUSTOMER' },
        { text: 'Placówka', value: 'SHOP' }
      ];
    },
    modeOptions () {
      return [
        { text: 'Zastąp (usuwa istniejące ceny)', value: 'REPLACE' },
        { text: 'Scal (nadpisuje istniejące, dodaje nowe)', value: 'MERGE' }
      ];
    },
    sourceOptionsPlaceholder () {
      if (!this.sourceType) {
        return 'Najpierw wybierz typ źródła...';
      }
      if (this.loadingSources) {
        return 'Ładowanie...';
      }
      return 'Wybierz źródło...';
    },
    canSubmit () {
      return this.sourceType && this.sourceId && this.mode;
    }
  },
  watch: {
    showModal (value) {
      if (value) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm () {
      this.sourceType = null;
      this.sourceId = null;
      this.mode = null;
      this.sourceOptions = [];
    },
    onSourceTypeChange () {
      this.sourceId = null;
      this.sourceOptions = [];

      if (!this.sourceType) {
        return;
      }

      this.loadingSources = true;
      let endpoint = '';

      if (this.sourceType === 'PRICE_LIST') {
        endpoint = '/price-lists/items';
      } else if (this.sourceType === 'CUSTOMER') {
        endpoint = '/customers/items';
      } else if (this.sourceType === 'SHOP') {
        endpoint = '/customers/shops/items';
      }

      this.$http.post(endpoint, { pagination: false }).then(response => {
        let options = response.data.data || [];
        if (this.entityType && this.sourceType === this.entityType) {
          options = options.filter(item => item.id !== parseInt(this.entityId, 10));
        }
        this.sourceOptions = options;
        this.loadingSources = false;
      }).catch(error => {
        console.error(error);
        this.loadingSources = false;
      });
    },
    submitLoadPrices () {
      this.submitting = true;

      this.$http.post(this.loadEndpoint + this.entityId, {
        source_type: this.sourceType,
        source_id: this.sourceId,
        mode: this.mode
      }).then(response => {
        this.submitting = false;

        if (response.data.success) {
          Vue.swal({
            title: 'Wczytano cennik',
            html: this.buildLoadSummary(response.data),
            type: 'success',
            confirmButtonText: 'OK',
            buttonsStyling: true
          }).then(() => {
            this.$emit('prices-loaded', response.data.prices);
          });
        } else {
          let message = response.data.message || 'Wczytywanie cennika nie powiodło się.';
          Vue.swal({
            title: 'Wystąpił błąd',
            html: message,
            type: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        }
      }).catch(error => {
        this.submitting = false;
        let errorText = 'Wczytywanie cennika nie powiodło się. Spróbuj ponownie.';

        if (error.response && error.response.data && error.response.data.errors) {
          let keys = Object.keys(error.response.data.errors);
          let backendErrors = [];
          for (let i = 0; i < keys.length; i++) {
            backendErrors.push(error.response.data.errors[keys[i]]);
          }
          errorText = backendErrors.join('<br>');
        }

        Vue.swal({
          title: 'Wystąpił błąd',
          html: errorText,
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
      });
    },
    buildLoadSummary (data) {
      let lines = [];
      if (data.added > 0) {
        lines.push('Dodano nowych: ' + data.added);
      }
      if (data.updated > 0) {
        lines.push('Zaktualizowano: ' + data.updated);
      }
      if (data.removed > 0) {
        lines.push('Usunięto: ' + data.removed);
      }
      return lines.length ? lines.join('<br>') : 'Brak zmian w cenniku.';
    }
  }
};
</script>

<style lang="scss">
.load-prices-modal {
  .modal-dialog {
    max-width: none;
    width: 50%;
    .modal-content {
      .modal-body {
        overflow: auto;
        max-height: 760px;
      }
    }
  }
}
</style>
